import {
  Box,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  chakra,
  useTab,
  Text,
} from '@chakra-ui/react';
import { forwardRef } from 'react';

import { VouchToUser } from './VouchToUser';
import { VouchForJob } from './VouchForJob';

const StyledTab = chakra(Box, { themeKey: 'Tabs.Tab' });
const CustomTab = forwardRef((props, ref) => {
  const tabProps = useTab({ ...props, ref });
  const isSelected = !!tabProps['aria-selected'];
  return (
    <StyledTab
      flex={1}
      textAlign="center"
      height="40px"
      px="16px"
      _focus={{ boxShadow: 'none' }}
      color="light.highlight"
      borderBottomWidth={isSelected ? '4px' : '0'}
      borderBottomColor={isSelected ? 'light.highlight' : ''}
      cursor="pointer"
      {...tabProps}
    >
      <Text
        fontSize="md"
        color={isSelected ? 'light.text-primary' : 'light.text-secondary'}
        variant={isSelected ? '' : 'muted'}
        fontWeight={isSelected ? 700 : 400}
      >
        {props.title}
      </Text>
    </StyledTab>
  );
});

const VouchTab = ({ offices = [], departments = [], isAtsIntegrated }) => {
  return (
    <Tabs
      defaultIndex={offices?.length && departments?.length ? 0 : 1}
      isFitted
      isLazy
    >
      <TabList borderBottom="1px solid #EDEDED">
        <CustomTab title="Jobs" />
        <CustomTab title="Users" />
      </TabList>
      <TabPanels>
        <TabPanel p="0" pt="12px">
          <VouchForJob
            departments={departments}
            offices={offices}
            isAtsIntegrated={isAtsIntegrated}
          />
        </TabPanel>
        <TabPanel p="0" pt="12px">
          <VouchToUser />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export const VouchList = ({ vouchOptions = {}, isAtsIntegrated }) => {
  const { ats_job_facets: { departments = [], offices = [] } = {} } =
    vouchOptions;

  return (
    <VouchTab
      departments={departments}
      offices={offices}
      isAtsIntegrated={isAtsIntegrated}
    />
  );
};
